module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/factfinder-suggest-product.lodash.tpl -->\n<div class="mdl_search__container mdl_search__container-main">\n    <div class="mdl_search__section mdl_search__section">\n        <div class="mdl_search__section-header">\n            <div class="mdl_search__section-title">Produktvorschläge</div>\n            <div class="mdl_search__section-cta en_hidden_desktop_up">\n                <button type="submit" form="header_search__form" class="mdl_search__section-cta-link">Alle anzeigen</button>\n            </div>\n        </div>\n        <div class="mdl_search__section-content">\n\n            <div class="mdl_search__suggestions-products mdl_search__suggestions-products--' +
((__t = ( productCols )) == null ? '' : __t) +
'-cols">\n                ';
 suggestions.forEach( productName => { ;
__p += '\n                <a href="' +
((__t = ( productName.Deeplink )) == null ? '' : __t) +
'" class="mdl_search__suggestions-product"\n                    ';
 if ( 'dataSuggest' in productName ) { ;
__p += ' data-suggest="' +
((__t = ( productName.dataSuggest )) == null ? '' : __t) +
'"';
 } ;
__p += '\n                    ';
 if ( 'slotId' in productName ) { ;
__p += ' data-slot-id="' +
((__t = ( productName.slotId )) == null ? '' : __t) +
'"';
 } ;
__p += '\n                >\n                    <div class="mdl_search__suggestions-product-image-wrapper">\n                        <img class="mdl_search__suggestions-product-image" src="' +
((__t = ( productName.ImageURL )) == null ? '' : __t) +
'" alt="' +
((__t = ( [productName.brand || '', productName.name || ''].join( ' | ' ) )) == null ? '' : __t) +
'" loading="lazy" width="192" height="256">\n                    </div>\n                    <div class="mdl_search__suggestions-product-data">\n                        <div class="mdl_search__suggestions-product-brand">' +
((__t = ( mark( productName.brand ) )) == null ? '' : __t) +
'</div>\n                        <div class="mdl_search__suggestions-product-name">' +
((__t = ( mark( productName.name ) )) == null ? '' : __t) +
'</div>\n                    </div>\n                </a>\n                ';
 }) ;
__p += '\n                <div class="mdl_search__suggestions-allproducts en_hidden_desktop_down">\n                    <button type="submit" form="header_search__form" class="en_button en_button--size_small">Alle anzeigen</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
};
